import { render } from "./WatchNow.vue?vue&type=template&id=010d2bab"
import script from "./WatchNow.vue?vue&type=script&lang=js"
export * from "./WatchNow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__